import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-month-of-year-single-select',
  templateUrl: './month-of-year-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthOfYearSingleSelectComponent {
  public _value: { name: string; value: number };

  public readonly options = [
    { name: 'Январь', value: 1 },
    { name: 'Февраль', value: 2 },
    { name: 'Март', value: 3 },
    { name: 'Апрель', value: 4 },
    { name: 'Май', value: 5 },
    { name: 'Июнь', value: 6 },
    { name: 'Июль', value: 7 },
    { name: 'Август', value: 8 },
    { name: 'Сентябрь', value: 9 },
    { name: 'Октябрь', value: 10 },
    { name: 'Ноябрь', value: 11 },
    { name: 'Декабрь', value: 12 }
  ];

  @Input() public isError = false;
  @Input() public appendTo: string;

  @Input() public set value(value: number) {
    this._value = this.options.find((opt) => opt.value === value);
  }

  @Output() public valueChange = new EventEmitter<number>();
}
